import { toFloat } from 'radash';
import { parse as papaparse, ParseResult } from 'papaparse';
import {
  DELMONICOS_QUARTER_OVERVIEW_EXTERNAL_ID_CARD,
  IGNORED_CHECKOUT_BREAKDOWN_TYPE,
} from 'src/config/app.config';
import {
  CheckoutModel,
  QuarterOverviewModel,
  LmsModel,
} from 'src/core/model/quarter-overview.model';

export function csvStringToFloat(value: string = ''): number {
  return toFloat(value.replace(',', '.'), 0);
}

function floatToCsvString(value?: number): string {
  return value?.toString()?.replace('.', ',') ?? '';
}

export function isIgnoredByBreakdownType(item: CheckoutModel): boolean {
  return (
    !!item.breakdownType &&
    IGNORED_CHECKOUT_BREAKDOWN_TYPE.includes(item.breakdownType)
  );
}

export function quarterOverviewModelToCsv(
  data: QuarterOverviewModel,
): string[] {
  return [
    data.id,
    data.date ?? '',
    data.chargePointName ?? '',
    data.customerId ?? '',
    data.connectorId ?? '',
    data.name ?? '',
    data.externalCardId ?? '',
    data.internalCardId ?? '',
    data.global ?? '',
    floatToCsvString(data.energyDelivered),
    floatToCsvString(data.totalHT),
    floatToCsvString(data.durationInMin),

    data.evseUid ?? '',
    floatToCsvString(data.totalHTDelmonicos),
    floatToCsvString(data.totalTTCDelmonicos),
    data.transactionId ?? '',
    data.iTransactionId ?? '',
    floatToCsvString(data.checkoutFees),
  ];
}

export function isDelmonicosLine(data: LmsModel): boolean {
  const regex = new RegExp(`^${DELMONICOS_QUARTER_OVERVIEW_EXTERNAL_ID_CARD}*`);

  return regex.test(data.externalCardId ?? '');
}

export async function parse(file: File): Promise<any[]> {
  return new Promise((resolve, reject) => {
    papaparse(file, {
      worker: true,
      skipEmptyLines: true,
      complete({ data, errors }: ParseResult<Record<string, unknown>>) {
        if (errors?.length > 0) {
          reject(new Error(errors[0].message));
          return;
        }

        resolve(data);
      },
    });
  });
}
